import Api from "../services/api"

export const evaluateSession = (userSession) => {
  if (userSession == null ||  userSession.user == null || userSession.user.userrole == null)
    Api.logoff()
}
